import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans flex flex-col" data-id="element-141">
      <main className="flex-grow py-16 px-4 md:px-8" data-id="element-142">
        <div className="max-w-4xl mx-auto" data-id="element-143">
          <Link to="/" className="inline-flex items-center gap-2 text-gold-primary hover:text-gold-accent transition-colors mb-12 font-medium" data-id="element-144">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-145" />
            Back to Home
          </Link>

          <div className="space-y-12" data-id="element-146">
            <header className="border-b border-gray-800 pb-8" data-id="element-147">
              <h1 className="font-serif text-4xl md:text-5xl mb-4 text-white" data-id="element-148">
                Privacy Policy
              </h1>
              <p className="text-gray-400" data-id="element-149">Last updated: April 2026</p>
            </header>

            <section className="space-y-4" data-id="element-150">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-151">
                1. Introduction
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-152">
                Cotifunding respects your privacy and is committed to protecting
                the personal information collected through our website and
                online forms. This Privacy Policy explains how we collect, use,
                and safeguard your information when you use our services.
              </p>
            </section>

            <section className="space-y-4" data-id="element-153">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-154">
                2. Information We Collect
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-155">
                We collect information that you voluntarily provide to us when
                submitting a funding request. This includes:
              </p>
              <ul className="list-disc pl-6 text-gray-300 space-y-2" data-id="element-156">
                <li data-id="element-157">Name</li>
                <li data-id="element-158">Email address</li>
                <li data-id="element-159">Phone number</li>
                <li data-id="element-160">
                  Business information (including revenue, time in business, and
                  credit score range)
                </li>
              </ul>
            </section>

            <section className="space-y-4" data-id="element-161">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-162">
                3. How We Use Information
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-163">
                The information we collect is used for the following purposes:
              </p>
              <ul className="list-disc pl-6 text-gray-300 space-y-2" data-id="element-164">
                <li data-id="element-165">To contact you regarding your funding request</li>
                <li data-id="element-166">To evaluate your eligibility for business funding</li>
                <li data-id="element-167">To provide relevant financial solutions and offers</li>
              </ul>
            </section>

            <section className="space-y-4 bg-charcoal p-6 rounded-xl border border-gray-800" data-id="element-168">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-169">
                4. SMS and Call Consent
              </h2>
              <p className="text-gray-300 leading-relaxed font-medium" data-id="element-170">
                By submitting your information through our forms, you agree to
                receive calls and text messages from Cotifunding regarding your
                inquiry. Message and data rates may apply. You may opt out at
                any time by replying STOP.
              </p>
            </section>

            <section className="space-y-4" data-id="element-171">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-172">
                5. Information Sharing
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-173">
                We do not sell your personal information to third parties. We
                may share your information with trusted funding partners
                strictly for the purpose of providing you with financing options
                and evaluating your request.
              </p>
            </section>

            <section className="space-y-4" data-id="element-174">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-175">
                6. Data Protection
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-176">
                We implement reasonable and appropriate security measures to
                protect your personal information against unauthorized access,
                alteration, disclosure, or destruction.
              </p>
            </section>

            <section className="space-y-4" data-id="element-177">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-178">
                7. Cookies
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-179">
                Our website may use cookies and similar tracking technologies to
                enhance functionality, analyze site usage, and improve your user
                experience.
              </p>
            </section>

            <section className="space-y-4" data-id="element-180">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-181">
                8. User Rights
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-182">
                You have the right to request access to the personal data we
                hold about you, or request that we delete your information. To
                exercise these rights, please contact us using the information
                below.
              </p>
            </section>

            <section className="space-y-4" data-id="element-183">
              <h2 className="font-serif text-2xl text-gold-primary" data-id="element-184">
                9. Contact Information
              </h2>
              <p className="text-gray-300 leading-relaxed" data-id="element-185">
                If you have any questions or concerns about this Privacy Policy
                or our data practices, please contact us at:
              </p>
              <a href="mailto:contact@cotifunding.com" className="text-gold-primary hover:text-gold-accent transition-colors inline-block mt-2" data-id="element-186">
                contact@cotifunding.com
              </a>
            </section>
          </div>
        </div>
      </main>
      <Footer data-id="element-187" />
    </div>;
}